module.exports = __webpack_public_path__ + "img/full-logo.3523679.svg?v=1764903765445";